import React, { useState, useEffect } from 'react';
import { FaExclamationTriangle, FaCheck, FaTimes } from 'react-icons/fa';

const AgeVerification: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setShow(true);
    }
  }, []);

  const handleVerify = () => {
    localStorage.setItem('ageVerified', 'true');
    setShow(false);
  };

  const handleExit = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm">
      <div className="glass-strong rounded-3xl p-8 md:p-12 max-w-md w-full border border-white/20 shadow-2xl">
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-gradient-to-br from-red-500 to-orange-500 rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-lg">
            <FaExclamationTriangle className="text-white text-3xl" />
          </div>
          <h2 className="text-3xl md:text-4xl font-black mb-4 heading-font">
            <span className="text-gradient">Vérification d'Âge</span>
          </h2>
          <p className="text-gray-300 text-lg">
            Vous devez avoir au moins 18 ans pour accéder à ce site
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleVerify}
            className="w-full px-6 py-4 bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 rounded-xl font-bold text-white hover:shadow-xl hover:shadow-purple-500/50 transition-all duration-300 flex items-center justify-center space-x-2"
          >
            <FaCheck />
            <span>J'ai plus de 18 ans</span>
          </button>
          <button
            onClick={handleExit}
            className="w-full px-6 py-3 glass rounded-xl font-semibold text-gray-300 hover:text-white hover:bg-white/10 transition-all duration-300"
          >
            J'ai moins de 18 ans
          </button>
        </div>

        <p className="text-xs text-gray-500 text-center mt-6">
          Conformément à la réglementation française, l'accès à ce site est réservé aux personnes majeures.
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;

